export enum FEATURE_FLAG {
  SHOWCASE = 'showcase',
  HOME = 'home',
  TEAM = 'team',
  PARTNER_DETAILS = 'partner-details',
}

export type FeatureFlags = Readonly<Record<FEATURE_FLAG, boolean>>;
